import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { ScrollArea } from '../../components/ui/scroll-area';
import { Package } from 'lucide-react';

export function SubstitutesDialog({ open, onOpenChange, substitutesData, onAddSubstitute }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Salt-Based Substitutes</DialogTitle>
        </DialogHeader>
        {substitutesData && (
          <div className="space-y-4">
            <div className="p-3 bg-slate-50 rounded-lg">
              <p className="text-sm text-slate-500">Looking for alternatives to:</p>
              <p className="font-semibold">{substitutesData.original.brand_name}</p>
              <p className="text-sm text-mint-600">Salt: {substitutesData.original.salt_composition}</p>
            </div>
            <SubstitutesList substitutes={substitutesData.substitutes} onAdd={onAddSubstitute} />
            <p className="text-xs text-slate-400 text-center">Click on a substitute to add it to cart</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

function SubstitutesList({ substitutes, onAdd }) {
  if (!substitutes || substitutes.length === 0) {
    return (
      <div className="text-center py-8 text-slate-400">
        <Package className="w-12 h-12 mx-auto mb-2 opacity-50" />
        <p>No substitutes with same salt composition available in stock</p>
      </div>
    );
  }

  const items = [];
  for (let i = 0; i < substitutes.length; i++) {
    const sub = substitutes[i];
    items.push(
      <div key={sub.id} className="p-3 border rounded-lg hover:bg-mint-50 cursor-pointer transition-colors" onClick={function() { onAdd(sub); }}>
        <div className="flex justify-between items-start">
          <div>
            <p className="font-medium">{sub.brand_name}</p>
            <p className="text-xs text-slate-500">{sub.manufacturer}</p>
          </div>
          <div className="text-right">
            <p className="font-bold text-mint-600">Rs.{sub.mrp}</p>
            <p className="text-xs text-slate-500">Stock: {sub.total_stock}</p>
          </div>
        </div>
      </div>
    );
  }
  return <ScrollArea className="h-64"><div className="space-y-2">{items}</div></ScrollArea>;
}
